import { render } from "./PartnerRequestListItem.vue?vue&type=template&id=15d8f6b3&scoped=true&ts=true"
import script from "./PartnerRequestListItem.vue?vue&type=script&lang=ts"
export * from "./PartnerRequestListItem.vue?vue&type=script&lang=ts"

import "./PartnerRequestListItem.vue?vue&type=style&index=0&id=15d8f6b3&scoped=true&lang=css"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d8f6b3"]])

export default __exports__